import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height", "fill"];
const _hoisted_2 = ["xlink:href"];
export default /*@__PURE__*/ _defineComponent({
    __name: 'Icon',
    props: {
        name: {},
        size: {},
        color: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", {
                class: "custom-icon",
                width: _ctx.size || '18px',
                height: _ctx.size || '18px',
                fill: _ctx.color || 'currentColor'
            }, [
                _createElementVNode("use", {
                    "xlink:href": `#${_ctx.name}`
                }, null, 8, _hoisted_2)
            ], 8, _hoisted_1));
        };
    }
});
